import { DialogContent, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles"
import { useColors } from "../../Context/ColorsContext"
import { MediaQuerys } from "../../styles/GlobalStyle";
const { mobile, tablet, desktop } = MediaQuerys;

export const CustomDialogContent = styled(DialogContent)(() => {
    const { colors } = useColors();
    return {
        displays: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        background: colors.white,
        [mobile]: {
            '&::-webkit-scrollbar': {
                width: 5,
                height: 5
            },
            overflowY: 'hidden',
        }
    }
});

export const Title = styled(Typography)(({isCode}) => {
    const { colors } = useColors();
    return {
        fontSize: '14px',
        fontWeight: 'bold',
        color: isCode ? colors.buttonActionColor : colors.sidebarSelectColor,
        [tablet]: {
            fontSize: '12px'
        }
    }
});

export const CustomIconButton = styled(IconButton)(() => {
    const { colors } = useColors();
    return {
        borderRadius: '50%',
        marginLeft: 10,
        backgroundColor: colors.background,
        color: colors.buttonActionColor,
        "&:hover": {
            backgroundColor: colors.buttonActionColor,
            opacity: 0.9,
            color: colors.background,
        }
    }
})